module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d925ccf215dcd4077e9e1a1f69a6dc81.png";